"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Doc_exports = {};
__export(Doc_exports, {
  default: () => Doc_default
});
module.exports = __toCommonJS(Doc_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.67188 6.91016C6.67188 6.77995 6.71745 6.66927 6.80859 6.57812C6.91276 6.47396 7.02995 6.42188 7.16016 6.42188H8.83984C8.97005 6.42188 9.08073 6.47396 9.17188 6.57812C9.27604 6.66927 9.32812 6.77995 9.32812 6.91016C9.32812 7.05339 9.27604 7.17708 9.17188 7.28125C9.08073 7.3724 8.97005 7.41797 8.83984 7.41797H7.16016C7.02995 7.41797 6.91276 7.3724 6.80859 7.28125C6.71745 7.17708 6.67188 7.05339 6.67188 6.91016ZM7.16016 8.92188C7.02995 8.92188 6.91276 8.97396 6.80859 9.07812C6.71745 9.16927 6.67188 9.27995 6.67188 9.41016C6.67188 9.55339 6.71745 9.67708 6.80859 9.78125C6.91276 9.8724 7.02995 9.91797 7.16016 9.91797H13C13.1432 9.91797 13.2604 9.8724 13.3516 9.78125C13.4557 9.67708 13.5078 9.55339 13.5078 9.41016C13.5078 9.27995 13.4557 9.16927 13.3516 9.07812C13.2604 8.97396 13.1432 8.92188 13 8.92188H7.16016ZM6.67188 11.9102C6.67188 11.7799 6.71745 11.6693 6.80859 11.5781C6.91276 11.474 7.02995 11.4219 7.16016 11.4219H12.1602C12.3034 11.4219 12.4206 11.474 12.5117 11.5781C12.6159 11.6693 12.668 11.7799 12.668 11.9102C12.668 12.0534 12.6159 12.1771 12.5117 12.2812C12.4206 12.3724 12.3034 12.418 12.1602 12.418H7.16016C7.02995 12.418 6.91276 12.3724 6.80859 12.2812C6.71745 12.1771 6.67188 12.0534 6.67188 11.9102ZM7.16016 13.9219C7.02995 13.9219 6.91276 13.974 6.80859 14.0781C6.71745 14.1693 6.67188 14.2799 6.67188 14.4102C6.67188 14.5534 6.71745 14.6771 6.80859 14.7812C6.91276 14.8724 7.02995 14.918 7.16016 14.918H13.8398C13.9701 14.918 14.0807 14.8724 14.1719 14.7812C14.276 14.6771 14.3281 14.5534 14.3281 14.4102C14.3281 14.2799 14.276 14.1693 14.1719 14.0781C14.0807 13.974 13.9701 13.9219 13.8398 13.9219H7.16016ZM5.5 1.91016H15.5C15.9557 1.91016 16.3464 2.07292 16.6719 2.39844C16.9974 2.72396 17.1602 3.12109 17.1602 3.58984V16.9102C17.1602 17.3789 16.9974 17.776 16.6719 18.1016C16.3464 18.4271 15.9557 18.5898 15.5 18.5898H5.5C5.04427 18.5898 4.65365 18.4271 4.32812 18.1016C4.0026 17.776 3.83984 17.3789 3.83984 16.9102V3.58984C3.83984 3.12109 4.0026 2.72396 4.32812 2.39844C4.65365 2.07292 5.04427 1.91016 5.5 1.91016ZM16.1641 16.9102V3.58984C16.1641 3.40755 16.099 3.2513 15.9688 3.12109C15.8385 2.99089 15.6823 2.92578 15.5 2.92578H5.5C5.31771 2.92578 5.16146 2.99089 5.03125 3.12109C4.90104 3.2513 4.83594 3.40755 4.83594 3.58984V16.9102C4.83594 17.0924 4.90104 17.2487 5.03125 17.3789C5.16146 17.5091 5.31771 17.5742 5.5 17.5742H15.5C15.6823 17.5742 15.8385 17.5091 15.9688 17.3789C16.099 17.2487 16.1641 17.0924 16.1641 16.9102Z",
      fill: "currentColor"
    }
  )
);
const SvgDoc = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Doc_default = SvgDoc;
